"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappTracker = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function trackerKey(block, shortcode) {
  return `${block}-${shortcode}`;
}
function trackerKeyFor(data) {
  return trackerKey(data.block, data.shortcode);
}

/**
 * Tracks the statuses of dumbapps for the palette, allowing the dumbapp-result
 * variables to load their data.
 */
class DumbappTracker {
  constructor(paletteName) {
    (0, _defineProperty2.default)(this, "latest", {});
    (0, _defineProperty2.default)(this, "variables", []);
    (0, _defineProperty2.default)(this, "getValue", variable => {
      if (variable.shortcode) {
        let it = this.variables.find(it => it.variable === variable);
        let key = trackerKey(it.block, variable.shortcode);
        return this.latest[key];
      }
      return null;
    });
    this.paletteName = paletteName;
  }
  dumbappUpdated(submission) {
    var _submission$extras;
    if ((_submission$extras = submission.extras) !== null && _submission$extras !== void 0 && _submission$extras.palette) {
      var _submission$extras2;
      let data = (_submission$extras2 = submission.extras) === null || _submission$extras2 === void 0 ? void 0 : _submission$extras2.palette;
      if (data.name === this.paletteName) {
        this.latest[trackerKeyFor(data)] = submission;
        for (let it of this.variables) {
          if (this.paletteName === data.name && it.block === data.block && it.variable.shortcode === data.shortcode) {
            it.variable.update(submission);
          }
        }
      }
    }
  }
  addVariable(variable, block) {
    this.variables.push({
      variable,
      block
    });
    variable.trackerValue = this.getValue;
    if (variable.shortcode) {
      let key = trackerKey(block, variable.shortcode);
      if (this.latest[key]) {
        variable.update(this.latest[key]);
      }
    }
  }
  removeVariable(variable) {
    let index = this.variables.findIndex(it => it.variable === variable);
    if (index > -1) {
      this.variables.splice(index, 1);
    }
    variable.trackerValue = undefined;
  }
}
exports.DumbappTracker = DumbappTracker;
//# sourceMappingURL=DumbappTracker.js.map